import { useTranslation } from 'react-i18next';

export const EDKContents = () => {
  const { t } = useTranslation();

  const kitItems = [
    { key: 'item1', icon: 'ri-book-open-line', color: 'text-orange-400', bg: 'bg-orange-900/20', border: 'border-orange-500/20' },
    { key: 'item2', icon: 'ri-leaf-line', color: 'text-green-400', bg: 'bg-green-900/20', border: 'border-green-500/20' },
    { key: 'item3', icon: 'ri-plant-line', color: 'text-emerald-400', bg: 'bg-emerald-900/20', border: 'border-emerald-500/20' },
    { key: 'item4', icon: 'ri-flashlight-line', color: 'text-yellow-400', bg: 'bg-yellow-900/20', border: 'border-yellow-500/20' },
    { key: 'item5', icon: 'ri-shield-flash-line', color: 'text-red-400', bg: 'bg-red-900/20', border: 'border-red-500/20' },
    { key: 'item6', icon: 'ri-drop-line', color: 'text-amber-400', bg: 'bg-amber-900/20', border: 'border-amber-500/20' },
    { key: 'item7', icon: 'ri-sun-line', color: 'text-cyan-400', bg: 'bg-cyan-900/20', border: 'border-cyan-500/20' },
    { key: 'item8', icon: 'ri-quill-pen-line', color: 'text-violet-400', bg: 'bg-violet-900/20', border: 'border-violet-500/20' },
    { key: 'item9', icon: 'ri-fire-line', color: 'text-orange-500', bg: 'bg-orange-900/20', border: 'border-orange-600/20' },
    { key: 'item10', icon: 'ri-candle-line', color: 'text-white', bg: 'bg-white/5', border: 'border-white/15' },
  ];

  const guarantees = [
    { icon: 'ri-shield-check-line', key: 'edk_cont_pure' },
    { icon: 'ri-leaf-line', key: 'edk_cont_no_synth' },
    { icon: 'ri-time-line', key: 'edk_cont_ancient' },
    { icon: 'ri-customer-service-line', key: 'edk_cont_guaranteed' },
  ];

  return (
    <section id="inhoud" className="w-full py-24 bg-[#060000]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-orange-400 text-xs font-semibold uppercase tracking-widest mb-3">{t('edk_cont_badge')}</p>
          <h2 className="text-3xl lg:text-5xl font-black text-white mb-5">
            {t('edk_cont_title').split(' ').slice(0, 2).join(' ')}{' '}
            <span className="text-transparent bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text">
              {t('edk_cont_title').split(' ').slice(2).join(' ')}
            </span>
          </h2>
          <p className="text-white/40 text-sm max-w-2xl mx-auto leading-relaxed">
            {t('edk_cont_sub')}
          </p>
        </div>

        {/* Main product image + summary */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative rounded-3xl overflow-hidden border border-orange-500/20">
            <div className="h-80 lg:h-[480px]">
              <img
                src="https://public.readdy.ai/ai/img_res/cf28183f138418b4b3d76547dac7c011.jpg"
                alt="Evil Energy Destroy Kit inhoud"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#060000]/70 to-transparent" />
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <div className="flex items-center gap-3 bg-[#060000]/80 backdrop-blur-xl border border-orange-500/20 rounded-2xl p-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-600/30 border border-orange-500/30 shrink-0">
                  <i className="ri-box-3-line text-orange-400 text-lg" />
                </div>
                <div>
                  <p className="text-white font-black text-sm">{t('edk_cont_summary')}</p>
                  <p className="text-white/40 text-xs">{t('edk_cont_summary_sub')}</p>
                </div>
                <div className="ml-auto text-right shrink-0">
                  <p className="text-white/30 text-xs line-through">{t('edk_cont_old_price')}</p>
                  <p className="text-orange-400 font-black text-lg">{t('edk_cont_price')}</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-gradient-to-br from-orange-900/15 to-red-900/10 border border-orange-500/20 rounded-3xl p-8 mb-6">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-600/20 border border-orange-500/25 shrink-0">
                  <i className="ri-book-open-line text-orange-400 text-xl" />
                </div>
                <div>
                  <h3 className="text-white font-black text-xl mb-1">{t('edk_cont_blueprint_title')}</h3>
                  <p className="text-orange-300/70 text-sm">{t('edk_cont_blueprint_sub')}</p>
                </div>
              </div>
              <p className="text-white/55 text-sm leading-relaxed mb-4">{t('edk_cont_blueprint_p1')}</p>
              <p className="text-white/40 text-sm leading-relaxed">{t('edk_cont_blueprint_p2')}</p>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {guarantees.map(item => (
                <div key={item.key} className="flex items-center gap-2.5 bg-white/3 border border-white/8 rounded-xl p-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className={`${item.icon} text-orange-400 text-sm`} />
                  </div>
                  <span className="text-white/60 text-xs leading-tight">{t(item.key)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* All items grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {kitItems.map((item, i) => (
            <div
              key={item.key}
              className={`relative border ${item.border} rounded-2xl p-5 hover:scale-[1.02] transition-transform bg-black/20`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${item.bg} border ${item.border}`}>
                  <i className={`${item.icon} ${item.color} text-lg`} />
                </div>
                <span className={`text-xs px-2 py-1 rounded-full ${item.bg} border ${item.border} ${item.color} font-medium`}>
                  {t(`edk_cont_${item.key}_tag`)}
                </span>
              </div>
              <h4 className="text-white font-bold text-sm mb-2">{t(`edk_cont_${item.key}_name`)}</h4>
              <p className="text-white/45 text-xs leading-relaxed">{t(`edk_cont_${item.key}_desc`)}</p>
              <div className="absolute top-3 right-3 text-white/10 font-black text-3xl leading-none pointer-events-none select-none">
                {String(i + 1).padStart(2, '0')}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
